import { FOCUS_RING } from '@/Components/Marketing/focusRing';
import SmartLink from '@/Components/Marketing/SmartLink';
import { cn } from '@/lib/utils';

/**
 * The small sentence-case label above a headline, orange on its soft tint
 * (only light pages carry one). Pages use at most one per three sections.
 * With `href` the whole pill is a link, and only a linked eyebrow reacts to
 * the pointer: an outline. No arrow: it is a label, not the section's call
 * to action (audit 26).
 */
export default function Eyebrow({ href, external, as: Tag = 'p', className, children, ...props }) {
    const classes = cn(
        'inline-flex w-fit items-center gap-2 rounded-full bg-mk-orange-soft px-3 py-1 text-sm font-medium text-mk-orange-label',
        className,
    );

    if (href == null) {
        return (
            <Tag className={classes} {...props}>
                {children}
            </Tag>
        );
    }

    return (
        <SmartLink
            href={href}
            external={external}
            className={cn(
                classes,
                'transition duration-500 ease-mk',
                FOCUS_RING,
                'ring-1 ring-transparent hover:ring-mk-orange-label/25',
            )}
            {...props}
        >
            {children}
        </SmartLink>
    );
}
